// import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';

export const FormSix = ({ handleSubmit, handleEditSubmit, handleUpdateNonmember, onBack, formSix, setformSix, location }) => {

    const handleChange = (e) => {
        const { name, value } = e.target
        setformSix(prev => ({ ...prev, [name]: value }));
    }

    return (
        <form >
            <div className="row">
                <div className="col-md-12 mt-3 d-none">
                    <label >Twitter Link:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Twitter Link"
                        name="dribbbleLink"
                        value={formSix.dribbbleLink}
                        onChange={handleChange}
                        autoComplete="off"
                        required
                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Facebook Link:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Facebook Link"
                        name="facebookLink"
                        value={formSix.facebookLink}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Instagram Link:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Instagram Link"
                        name="instaLink"
                        value={formSix.instaLink}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >LinkedIn Link:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter LinkedIn Link"
                        name="linkedInLink"
                        value={formSix.linkedInLink}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Youtube Link:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Youtube Link"
                        name="youtubeLink"
                        value={formSix.youtubeLink}
                        onChange={handleChange}
                        required
                    />
                </div>
                <div className="col-md-12 mt-3 ">
                    <label >Neoo Business Page Link:<span className="text-danger">&nbsp;*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Neoo Business Page Link"
                        name="neooBusinessPageLink"
                        value={formSix.neooBusinessPageLink}
                        onChange={handleChange}
                        required
                    />
                </div>
            </div>
            {/* Your form fields for the second step */}
            <Button onClick={onBack} variant="contained" className='mx-2 mt-2'>
                Back
            </Button>
            {
                location?.state?.memberStatus ?
                    <Button onClick={(e) => handleEditSubmit(e)} variant="contained" color="primary" className='mx-2 mt-2'>
                        UPDATE
                    </Button>
                    :
                    location?.state?.memberStatus === false ?

                        <Button onClick={(e) => handleUpdateNonmember(e, location?.state?._id)} variant="contained" color="primary" className='mx-2 mt-2'>
                            UPDATE NONMEMBER
                        </Button>
                        :
                        <Button onClick={(e) => handleSubmit(e)} variant="contained" color="primary" className='mx-2 mt-2'>
                            SUBMIT
                        </Button>
            }


        </form>
    )
}
